import { render } from "./PortfolioAccounts.vue?vue&type=template&id=1d9695e2"
import script from "./PortfolioAccounts.vue?vue&type=script&lang=js"
export * from "./PortfolioAccounts.vue?vue&type=script&lang=js"
script.render = render

export default script